import { effect, Entity, exhaustMapWithTrailing, fromPromise, LiveData } from '@toeverything/infra';
import type { WorkspaceService } from '../../workspace';
import { EMPTY, map, mergeMap } from 'rxjs';
import type { WorkspacePermissionStore } from '../stores/permission';


export type DocPermissionType = {
  id: string;
  role: string;
}

export class DocPermission extends Entity {
  constructor(
    private readonly store: WorkspacePermissionStore,
    private readonly workspaceService: WorkspaceService
  ) {
    super();
  }

  permissions$ = new LiveData<DocPermissionType[] | undefined>(undefined);


  readonly revalidate = effect(
    map(() => this.workspaceService.workspace.id),
    exhaustMapWithTrailing(workspaceId => {
      return fromPromise(async signal => {
        return this.store.fetchAllDocsPermission(
          workspaceId,
          signal
        );
      }).pipe(
        mergeMap(data => {

          this.permissions$.setValue(data.workspace.allDocRoles);

          return EMPTY;
        }),
      );
    })
  );

  override dispose(): void {
    this.revalidate.unsubscribe();
  }

}